import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RolPlataforma } from '../models/novedades.models';
import { EstadoInvitacion, Postulacion } from '../models/postulaciones.models';

export interface DecisionPatrocinio {
  idPostulacion: string;
  decision: Extract<EstadoInvitacion, 'aceptada' | 'rechazada' | 'observada'>;
  rol: RolPlataforma;
  timestamp: string;
  comentario?: string;
  firmaPatrocinioRealizada: boolean;
}

@Injectable({ providedIn: 'root' })
export class PatrocinioDecisionesService {
  private readonly decisionesSubject = new BehaviorSubject<DecisionPatrocinio[]>([]);
  readonly decisiones$ = this.decisionesSubject.asObservable();

  registrarDecision(
    idPostulacion: string,
    decision: DecisionPatrocinio['decision'],
    rol: RolPlataforma,
    comentario?: string,
    firmaPatrocinioRealizada = false
  ): void {
    const restantes = this.decisionesSubject.value.filter((item) => item.idPostulacion !== idPostulacion);
    this.decisionesSubject.next([
      {
        idPostulacion,
        decision,
        rol,
        timestamp: new Date().toISOString(),
        comentario: comentario?.trim() || undefined,
        firmaPatrocinioRealizada,
      },
      ...restantes,
    ]);
  }

  registrarFirma(idPostulacion: string, rol: RolPlataforma): void {
    const existente = this.decisionesSubject.value.find((item) => item.idPostulacion === idPostulacion);
    this.registrarDecision(idPostulacion, existente?.decision ?? 'aceptada', rol, existente?.comentario, true);
  }

  aplicarDecisiones(postulaciones: Postulacion[]): Postulacion[] {
    const mapa = new Map(this.decisionesSubject.value.map((item) => [item.idPostulacion, item]));
    return postulaciones.map((item) => {
      const decision = mapa.get(item.idPostulacion);
      if (!decision) return item;
      return {
        ...item,
        estadoPostulacion: decision.decision === 'observada' ? 'observada' : item.estadoPostulacion,
        estadoInvitacion: decision.decision,
        estadoPatrocinio: decision.decision === 'aceptada' ? 'patrocinado' : decision.decision === 'rechazada' ? 'sin_patrocinio' : item.estadoPatrocinio,
        editablePorAyudante:
          decision.decision === 'rechazada' ? false : decision.decision === 'observada' ? true : item.editablePorAyudante,
        puedeEditar: decision.decision === 'observada' ? true : decision.decision === 'rechazada' ? false : item.puedeEditar,
        puedeEnviar: decision.decision === 'observada' ? true : decision.decision === 'rechazada' ? false : item.puedeEnviar,
        bloqueadaPorRechazoPatrocinio: decision.decision === 'rechazada',
        firmaPatrocinioRealizada: decision.firmaPatrocinioRealizada,
        ultimaActualizacion: decision.timestamp,
      };
    });
  }
}
